import React from 'react'

import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'

import { InfoIcon } from '../../InfoIcon'

export default function ServiceFee({
  eventPackage,
  handleChange,
  handleCheckboxChange,
  isEditable,
}) {
  const useFlatServiceFee = Boolean(eventPackage?.useFlatServiceFee)

  return (
    <>
      <div className="card-body-heading card-body-heading--sm">
        <Card.Title as="h5">Service fee</Card.Title>
        <Card.Subtitle as="h6">
          Optionally charge one service fee for the whole package instead of the
          organization&apos;s per-ticket package fee rules
        </Card.Subtitle>
      </div>
      <Form.Group className="form-group" controlId="useFlatServiceFee">
        <Form.Check
          type="checkbox"
          name="useFlatServiceFee"
          label="Charge a single service fee for this package"
          checked={useFlatServiceFee}
          onChange={handleCheckboxChange}
          disabled={isEditable}
        />
      </Form.Group>
      {useFlatServiceFee && (
        <Form.Group className="form-group" controlId="flatServiceFee">
          <div className="form-label--flex">
            <Form.Label>Package service fee</Form.Label>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip>
                  Charged once per package purchase, regardless of seat count.
                  Leaves processing fees and taxes unchanged.
                </Tooltip>
              }
            >
              <Button variant="link">
                <InfoIcon />
              </Button>
            </OverlayTrigger>
          </div>
          <Form.Control
            type="number"
            name="flatServiceFee"
            min="0"
            step="0.01"
            placeholder="0.00"
            value={
              eventPackage?.flatServiceFee === null ||
              eventPackage?.flatServiceFee === undefined
                ? ''
                : eventPackage.flatServiceFee
            }
            onChange={handleChange}
            disabled={isEditable}
          />
        </Form.Group>
      )}
    </>
  )
}
